'use client';

import { memo } from 'react';

import { flex } from '@flipster/styled-system/patterns';

import { SymbolLeft } from './symbol-left';
import { SymbolRight } from './symbol-right';

export const SymbolInfo = memo(() => {
  return (
    <section
      data-drag-handle
      className={flex({
        gridArea: 'symbol-info',
        flexDirection: { base: 'column', tablet: 'row' },
        h: { tablet: '100%' },
        px: { base: 6, tablet: 16 },
        py: { tabletDown: 'var(--grid-space)' },
        bgColor: 'background.default.level-0',
        rounded: { tablet: 'var(--grid-rounded)' },
        flex: { tablet: 1 },
      })}
    >
      <SymbolLeft />
      <SymbolRight />
    </section>
  );
});
